import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS } from "@utils/index";
import { useCommonStore } from "@stores/index";
import { UserProfileInterface } from "@interfaces/index";
import { useUserGetProfile, useUserEmailRequest } from "@providers/index";
import { useNotify } from "@hooks/index";
import {
  Button,
  MobileHeader,
  MobileProfile,
  DesktopProfile,
} from "@components/index";

export const ProfilePage = () => {
  const setState = useCommonStore(({ setState }) => setState);
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });
  const [userInfo, setUserInfo] = useState<UserProfileInterface>({});
  const notify = useNotify();

  const {
    isPending: isPendingGetProfile,
    isSuccess,
    data,
    isError,
    error,
  } = useUserGetProfile();

  const { mutate: mutateUserEmailRequest, isPending: isPendingEmailRequest } =
    useUserEmailRequest(
      () =>
        notify(
          "success",
          "The request for verifying your Email was sent successfully, please check your Email!",
        ),
      ({ message }) => notify("error", message),
    );

  useEffect(() => {
    if (isSuccess && data) {
      const length = data.businesses.length;
      setUserInfo({
        fullName: data.fullName,
        clientCode: data.clientCode,
        phone: data.phone,
        email: data.email,
        emailVerified: !!data.emailVerifiedAt,
        businesses: !length
          ? ""
          : `${length} active business${length > 1 ? "es" : ""}`,
      });
    }
  }, [isSuccess, data, setUserInfo]);

  useEffect(() => {
    if (isError && error) {
      notify("error", error.message);
    }
  }, [isError, error, notify]);

  useEffect(() => {
    setState({ isLoading: isPendingGetProfile || isPendingEmailRequest });
  }, [isPendingGetProfile, isPendingEmailRequest, setState]);

  return (
    <>
      {isMobile && <MobileHeader href="/" title="My profile" />}
      <div className="flex min-h-[calc(100dvh_-_66px)] flex-col justify-between gap-y-2 px-4 text-black-100 md:min-h-[calc(100dvh_-_152px)]">
        {isMobile ? (
          <MobileProfile
            userInfo={userInfo}
            onVerifyEmail={mutateUserEmailRequest}
          />
        ) : (
          <DesktopProfile
            userInfo={userInfo}
            onVerifyEmail={mutateUserEmailRequest}
          />
        )}
        {isMobile && (
          <Button title="Log out" variant="secondary" isLink href="/logout" />
        )}
      </div>
    </>
  );
};
